import { useState, useEffect } from 'react';
import { Box, Text } from '@chakra-ui/react';
import CommentInput from './CommentInput';
import CommentItem from './CommentItem/CommentItem';
import { arcadeApiClient } from 'apiClients';
import style from './Comments.module.css';
import { Comment } from 'types/Comment';
import useSWRInfinite from 'swr/infinite';
interface CommentsProps {
  itemId: number;
  topComment: Comment | null;
  commentsCount: number;
}
const fetcher = async (url: string) => await arcadeApiClient.get(url).then(res => res.data.comments);
export const Comments = ({
  itemId,
  topComment,
  commentsCount
}: CommentsProps) => {
  const [displayTopComment, setDisplayTopComment] = useState<boolean>(!!topComment);
  const [total, setTotal] = useState<number>(commentsCount);
  const ROWS_PER_PAGE = 5;
  const getKey = (pageIndex, previousPageData) => {
    if (previousPageData && !previousPageData.length) return null;
    return `/multi_platform/comments?newsfeed_item_id=${itemId}&page=${pageIndex}&rows_per_page=${ROWS_PER_PAGE}`;
  };
  const {
    data,
    size,
    setSize,
    error,
    mutate
  } = useSWRInfinite(getKey, fetcher, {
    initialSize: 0
  });
  useEffect(() => {
    if (error) {
      console.error(error);
    }
  }, [error]);
  if (!data) return null;
  const deleteComment = (commentId: number) => {
    arcadeApiClient.delete(`/multi_platform/comments/${commentId}`).then(() => {
      mutate();
      setTotal(total - 1);
      if (commentId === topComment?.id) {
        setDisplayTopComment(false);
      }
    }).catch(console.error);
  };
  const onCreateComment = (newComment: Comment) => {
    mutate(pages => {
      if (!pages || pages.length === 0) {
        return [[newComment]];
      }
      const updatedPages = [...pages];
      updatedPages[0] = [newComment, ...updatedPages[0]];
      if (updatedPages[0].length > ROWS_PER_PAGE) {
        updatedPages[0].pop();
      }
      return updatedPages;
    }, false);
    setTotal(total + 1);
  };
  const commentsLoaded = data.reduce((acc, page) => acc + page.length, 0);
  const canViewMore = commentsLoaded < total && commentsCount > 1;
  return <Box className={style.commentsContainer} data-sentry-element="Box" data-sentry-component="Comments" data-sentry-source-file="Comments.tsx">
      <CommentInput itemId={itemId} onCreateComment={onCreateComment} data-sentry-element="CommentInput" data-sentry-source-file="Comments.tsx" />
      {displayTopComment && topComment && <CommentItem comment={topComment} isTopComment={true} deleteComment={deleteComment} />}
      {topComment && data?.length > 0 && <hr className={style.divider} />}
      {data.map(comments => comments.map(comment => <CommentItem comment={comment} deleteComment={deleteComment} key={comment.id} />))}
      {canViewMore && <Box className={style.viewComments}>
          <button onClick={() => setSize(size + 1)}>
            <Text>View more comments</Text>
          </button>
        </Box>}
    </Box>;
};